<script setup lang="ts">
import { useTranslation } from '@hfc/ui-core';

const { t } = useTranslation();
</script>

<template>
  <feedback-modal :label="t('footer.shareFeedback')" display-mode="link"></feedback-modal>
</template>
